// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3MLQW","errorLogs":"styles_errorLogs__VMKAS"};